import { CustomRouteSegment } from '../types/CustomRoute';

export const stubbedCustomRouteSegment: CustomRouteSegment = {
  id: 0,
  color: 'red',
  elevationPoints: [],
  paths: [],
  distance: 0,
  elevationGain: 0
};
